export const OHL = {
    name: 'DV 101A/3 TS SMEDEREVO 1 - TS SMEDEREVO 4',
    voltage: '110',
    regionCode: 'BGD',
    stanice: [],
    position: 'S',
    stubovi: [
        { index: 1, name: 'P-04', lat: 44.6505 , lng: 20.9457, sys: 1, portal: true},
        { index: 2, name: '72', lat: 44.6506 , lng: 20.9462, sys: 2},
        { index: 3, name: '71', lat: 44.6515 , lng: 20.9481, sys: 2},
        { index: 4, name: '70', lat: 44.6529 , lng: 20.9511, sys: 2},
        { index: 5, name: '69', lat: 44.6539 , lng: 20.9533, sys: 2},
        { index: 6, name: '9Z', lat: 44.6545 , lng: 20.9545, sys: 3},
        { index: 7, name: '8Z', lat: 44.6549 , lng: 20.9542, sys: 2},
        { index: 8, name: '7Z', lat: 44.6574 , lng: 20.9522, sys: 2},
        { index: 9, name: '6Z', lat: 44.66 , lng: 20.9502, sys: 2},
        { index: 10, name: '5Z', lat: 44.6625 , lng: 20.9483, sys: 2},
        { index: 11, name: '4Z', lat: 44.6643 , lng: 20.9468, sys: 2},
        { index: 12, name: '3Z', lat: 44.667 , lng: 20.9448, sys: 2},
        { index: 13, name: '2Z', lat: 44.6692 , lng: 20.9431, sys: 2},
        { index: 14, name: '1Z', lat: 44.67 , lng: 20.9418, sys: 2},
        { index: 15, name: 'P-02', lat: 44.6702 , lng: 20.9412, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-04 - 72', position: [{ lat: 44.6505 , lng: 20.9457 }, { lat: 44.6506 , lng: 20.9462 }] },
        { name: '72 - 71', position: [{ lat: 44.6506 , lng: 20.9462 }, { lat: 44.6515 , lng: 20.9481 }] },
        { name: '71 - 70', position: [{ lat: 44.6515 , lng: 20.9481 }, { lat: 44.6529 , lng: 20.9511 }] },
        { name: '70 - 69', position: [{ lat: 44.6529 , lng: 20.9511 }, { lat: 44.6539 , lng: 20.9533 }] },
        { name: '69 - 9Z', position: [{ lat: 44.6539 , lng: 20.9533 }, { lat: 44.6545 , lng: 20.9545 }] },
        { name: '9Z - 8Z', position: [{ lat: 44.6545 , lng: 20.9545 }, { lat: 44.6549 , lng: 20.9542 }] },
        { name: '8Z - 7Z', position: [{ lat: 44.6549 , lng: 20.9542 }, { lat: 44.6574 , lng: 20.9522 }] },
        { name: '7Z - 6Z', position: [{ lat: 44.6574 , lng: 20.9522 }, { lat: 44.66 , lng: 20.9502 }] },
        { name: '6Z - 5Z', position: [{ lat: 44.66 , lng: 20.9502 }, { lat: 44.6625 , lng: 20.9483 }] },
        { name: '5Z - 4Z', position: [{ lat: 44.6625 , lng: 20.9483 }, { lat: 44.6643 , lng: 20.9468 }] },
        { name: '4Z - 3Z', position: [{ lat: 44.6643 , lng: 20.9468 }, { lat: 44.667 , lng: 20.9448 }] },
        { name: '3Z - 2Z', position: [{ lat: 44.667 , lng: 20.9448 }, { lat: 44.6692 , lng: 20.9431 }] },
        { name: '2Z - 1Z', position: [{ lat: 44.6692 , lng: 20.9431 }, { lat: 44.67 , lng: 20.9418 }] },
        { name: '1Z - P-02', position: [{ lat: 44.67 , lng: 20.9418 }, { lat: 44.6702 , lng: 20.9412 }] }
    ]
}
